import login from './login'
import user from './user'
import bank from './bank'
import titlebar from './titlebar'
import quota from './quota'
import loan from './loan'
import repay from './repay'
import apply from './apply'
import coupon from './coupon'
import extension from './extension'
import device from './device'
import daoliu from './daoliu'
import channel from './channel'
export default {
  login,
  user,
  bank,
  titlebar,
  quota,
  loan,
  repay,
  apply,
  coupon,
  extension,
  device,
  daoliu,
  channel
}
